import { render, staticRenderFns } from "./PromocionRegaloAspirador.vue?vue&type=template&id=37209faf&scoped=true&"
import script from "./PromocionRegaloAspirador.vue?vue&type=script&lang=js&"
export * from "./PromocionRegaloAspirador.vue?vue&type=script&lang=js&"
import style0 from "./PromocionRegaloAspirador.vue?vue&type=style&index=0&id=37209faf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37209faf",
  null
  
)

export default component.exports